// extracted by mini-css-extract-plugin
export default {"form":"PromptForm_form__5E2lH","actions":"PromptForm_actions__lyGz1","error":"PromptForm_error__oWV9E"};